import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";

import Menu from "./Menu";

const Wrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding-left: ${props => props.theme.grid.outerMargin};
  padding-right: ${props => props.theme.grid.outerMargin};
  background: ${props => props.theme.colors.primaryDark};
  border-bottom: 1px solid ${props => props.theme.colors.primaryDarkDim};
  z-index: 10000;
`;

class Header extends Component {
  static PropTypes = {
    isMenuOpen: PropTypes.bool.isRequired,
    onMainMenuToggle: PropTypes.func.isRequired
  };

  render() {
    const { onMainMenuToggle, isMenuOpen } = this.props;

    return (
      <Wrapper>
        <Menu onMainMenuToggle={onMainMenuToggle} isMenuOpen={isMenuOpen} />
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  activeChapterId: !!state.book ? state.book.activeChapterId : 0
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/headers/Header.js